import React, { Component } from 'react'
import './dt.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import ToastColor from '../../../component/ToastColor'

@inject('store')
@observer

export default class newIndex extends Component {
  constructor(props) {
    super(props)
    this.tasksStore = this.props.store.register('activity/tasks')
  }
  state = {
    desc: "",
    tasksList: [],
    isAll: false,
    isShow: 0,
    lang:langM.en,
    language:'en',
  }

  RunOnStart = async (uid) => {
    this.setState({
      uid: uid
    })
    try {
      let list = await this.tasksStore.getTasksList()
      this.setState({
        tasksList: list
      })
      let isAll = this.state.tasksList.every((item) => {
        return item.isDone >= 2
        // return item.isDone <= 12
      })
      this.setState({
        isAll: isAll
      })
    } catch (error) {
      console.log(error)
      return new Error(error)
    }
  }

  async componentDidMount() {
    setDocumentTitle("Daily Tasks")
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlang(language)
    const pos = language == 'ar' ? '2.1rem' : '0'
    this.setState({
      lang: setlang(language, langM),
      language: language,
      position: pos,
      position2: pos
    })
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }

  getReward = async (state, id) => {
    if (state == 1) {
      let res = await this.refs.toast.hideRule(true)
      if (res) {
        this.setState({
          desc: this.state.lang.t1
        })
      }
    }
    if (state == 2) {
      let res = await this.refs.toast.hideRule(true)
      if (res) {
        // 提示文字
        this.setState({
          desc: this.state.lang.t2
        })
        // 领取奖励
        let res = await this.tasksStore.getReward(id)
        console.log(res, '我是奖励')
        // 重新刷新列表
        let list = await this.tasksStore.getTasksList()
        this.setState({
          tasksList: list
        })
      }
    }
    if (state == 3) {
      let res = await this.refs.toast.hideRule(true)
      if (res) {
        this.setState({
          desc: this.state.lang.t3
        })
      }
    }
  }
  render() {
    let tasksList = [
      {
        name: "在任何一条moment下留言评论1次",
        icon: "/img/activity/dailytasks/icon/comment.png",
        gold: 5,
        progress: "(1/2)",
        isDone: 1
      },
      {
        name: "游玩扭蛋机抽奖200抽",
        icon: "/img/activity/dailytasks/icon/egg.png",
        gold: 10,
        progress: "(2/2)",
        isDone: 2
      },
      {
        name: "游玩水果机赢得300金币",
        icon: "/img/activity/dailytasks/icon/fruit.png",
        gold: 10,
        progress: "(0/2)",
        isDone: 3
      },
      {
        name: "参与猜拳PK获得胜利3次",
        icon: "/img/activity/dailytasks/icon/finger.png",
        gold: 10,
        progress: "(0/2)",
        isDone: 1
      },
      {
        name: "当日发表一次moment",
        icon: "/img/activity/dailytasks/icon/moment.png",
        gold: 10,
        progress: "(0/2)",
        isDone: 1
      },
      {
        name: "结交一个新朋友",
        icon: "/img/activity/dailytasks/icon/friend.png",
        gold: 15,
        progress: "(0/2)",
        isDone: 1
      },
      {
        name: "给10条moment点赞",
        icon: "/img/activity/dailytasks/icon/comment.png",
        gold: 20,
        progress: "(0/2)",
        isDone: 1
      },
      {
        name: "送出任何礼物1次 ",
        icon: "/img/activity/dailytasks/icon/gift.png",
        gold: 20,
        progress: "(0/2)",
        isDone: 1
      },
    ]
    return (
      <div className='daily-task-part-main'>

        <div className="tips">
          {/* 提示 */}
          <ToastColor color={"rgba(0,0,0,.5)"} ref="toast" toastContent={this.state.desc} />
        </div>

        <div className="dt-banner">
          {/* <div className="title">
            Daily Tasks
          </div> */}
          {/* <div className="question" onClick={() => {
            if (this.state.isShow != 1) {
              this.setState({
                isShow: 1
              })
            } else {
              this.setState({
                isShow: 2
              })
            }
          }}>?</div> */}
        </div>

        {
          this.state.isAll && (
            <div className="dt-sign-in-part">
              <div className="title">
                {this.state.lang.t5}
                <img src="/img/app/service/success.png" alt="" />
              </div>
              {/* <div className="content">
              <div className="progress">
                <div className="circle"></div>
                <div className="inactive"></div>
                <div className="active"></div>
              </div>
              <div className="case"></div>
            </div> */}
            </div>
          )
        }


        <div className="dt-content-main">
          {
            this.state.tasksList && this.state.tasksList.map((item, index) => {
              return (
                <div className="dt-item" key={index}>
                  <div className="icon">
                    <img src={item.icon} alt="" />
                  </div>
                  <div className="desc">{item.name}</div>
                  <div className="gold">
                    +{item.gold}<img src="/img/gold.png" alt="" />
                  </div>

                  {
                    item.isDone == 1 &&
                    (<div className={`reward-btn`} onClick={() => this.getReward(1, item.taskid)}>{item.progress}</div>)
                  }
                  {
                    item.isDone == 2 &&
                    (<div className={`reward-btn active2`} onClick={() => this.getReward(2, item.taskid)}>{item.progress}</div>)
                  }
                  {
                    item.isDone == 3 &&
                    (<div className={`reward-btn`} onClick={() => this.getReward(3, item.taskid)}>{this.state.lang.t4}</div>)
                  }
                </div>
              )
            })
          }

        </div>
        <div className="cr">{this.state.lang.cr}</div>

        {/* <div className="se-wrap">
          <div className={`service ${this.state.isShow == 1 ? 'active' : ''} ${this.state.isShow == 2 ? 'inactive' : ''}`}>
            <span>
              每日任务：
            </span>
            <div>
              1. 完成每日任务，可以获得对应的金币。<br />
              2. 第二天清空任务进度。<br />
            </div>
            <div className='se-desc' onClick={jumpToUser.bind(this, 977239)}>
              If you have questions,please click here to contact customer service.
            </div>
          </div>
        </div> */}

      </div>
    )
  }
}


// WEBPACK FOOTER //
// src/pages/activity/dailytasks/tasks.js